import React, { Dispatch, SetStateAction } from 'react';
import { CellContext } from '@tanstack/react-table';

import { AdaptiveTableCell } from '@components/common';
import Actions from '@components/common/Actions';
import ColorBadge from '@components/routes/AdminPanel/SectorsSettings/ColorBadge';

import { ISectorSettingDTO } from '@interfaces/map/dto/sectorsDTO';

import { columnSizes } from '@constants/table';
import {
	deleteCellSettingsTooltip,
	editCellSettingsTooltip,
} from './constants';

export interface IGetColumnsParams {
	handleResetSettings?: () => void;
	isDeleteAvailable?: boolean;
	isReadOnly?: boolean;
	isResetAvailable?: boolean;
	openDeleteDialog: () => void;
	setCellSettingsIdForDelete: Dispatch<SetStateAction<string | undefined | null>>;
	setEditItem: Dispatch<SetStateAction<ISectorSettingDTO | null>>;
	toggleForm: () => void;
}

export const getColumns = ({
	isReadOnly,
	openDeleteDialog,
	setCellSettingsIdForDelete,
	setEditItem,
	toggleForm,
}: IGetColumnsParams) => {
	return [
		{
			header: 'TECHNOLOGY',
			accessorKey: 'technology',
			cell: ({ getValue }: CellContext<ISectorSettingDTO, any>) => {
				const tech = getValue();

				return <AdaptiveTableCell text={tech?.title} />;
			},
		},
		{
			header: 'BAND',
			accessorKey: 'band',
			cell: ({ getValue }: CellContext<ISectorSettingDTO, any>) => {
				const band = getValue();

				return <AdaptiveTableCell text={band?.title || 'n/a'} />;
			},
		},
		{
			header: 'RADIUS (METERS)',
			accessorKey: 'radius',
			cell: ({ getValue }: CellContext<ISectorSettingDTO, any>) => {
				const radius = getValue();

				return <AdaptiveTableCell text={radius} />;
			},
		},
		{
			header: 'BEAMWIDTH',
			accessorKey: 'beamwidth',
			cell: ({ getValue }: CellContext<ISectorSettingDTO, any>) => {
				const beamwidth = getValue();

				return <AdaptiveTableCell text={beamwidth} />;
			},
		},
		{
			header: 'COLOR ON THE MAP',
			accessorKey: 'colorId',
			enableSorting: false,
			cell: ({ getValue }: CellContext<ISectorSettingDTO, any>) => {
				const colorId = getValue();

				return <ColorBadge colorId={colorId} />;
			},
		},
		{
			header: 'Actions',
			align: 'actions',
			size: columnSizes.size100,
			enableSorting: false,
			accessorKey: 'actions',
			isHidden: isReadOnly,
			cell: ({ row }: CellContext<ISectorSettingDTO, any>) => {

				const handleDelete = () => {
					setCellSettingsIdForDelete(row.original.id);
					openDeleteDialog();
				};

				const handleEdit = () => {
					setEditItem(row.original);
					toggleForm();
				};

				return (
					<Actions
						deleteTooltip={deleteCellSettingsTooltip}
						editHandler={handleEdit}
						editTooltip={editCellSettingsTooltip}
						handleDelete={handleDelete}
						isDelete
						isDeleteDisable={row.original?.isCellExist}
						isEdit
					/>
				);
			},
		},
	];
};
